<template>
  <v-card
    :disabled="loading"
    :loading="loading"
    color="grey lighten-3"
    rounded="lg"
    class="AssignmentTestReport pa-3"
  >
    <ChipsColumns :items="reportInfoItems" class="mb-4" />

    <v-card-actions>
      <span>{{ attemptsInfoString }}</span>
      <v-spacer />
      <v-btn
        v-if="report.finished"
        :disabled="!previewAvailable"
        :loading="loading"
        large
        @click="$emit('preview', report)"
      >
        <v-icon left>open_in_browser</v-icon>
        Report results
      </v-btn>
      <v-btn
        v-else
        :loading="loading"
        :to="{ name: 'profile-assignment-test' }"
        large
      >
        <v-icon left>play_arrow</v-icon>
        Continue test
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { sortBy } from 'lodash';
import { mapGetters } from 'vuex';
import { getFinishedReportChips } from '@/helpers/assignments/lists';

export default {
  name: 'AssignmentTestReport',
  components: {
    ChipsColumns: () => import('../profiles/ChipsColumns'),
  },
  props: {
    assignment: {
      type: Object,
      default: () => ({}),
    },
    report: {
      type: Object,
      required: true,
    },
    testLoading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('assignments', [
      'assignmentsTimers',
    ]),
    loading() {
      return this.testLoading && !this.report.finished;
    },
    assignmentReportTimer() {
      if (this.assignmentsTimers[this.assignment._id]) {
        const format = 'HH:mm:ss';
        const durationStart = this.$moment.utc().startOf('day');
        const diff = this.$moment() - this.$moment(this.report.startDate);
        return durationStart.add(diff, 'ms').format(format);
      }
      return '00:00:00';
    },
    reportInfoItems() {
      const { report } = this;

      if (report.finished) {
        return getFinishedReportChips(report);
      }

      return [
        {
          icon: 'notes',
          title: 'Status',
          text: 'Running',
        },
        {
          icon: 'timer',
          title: 'Timer',
          text: this.assignmentReportTimer,
        },
        {
          icon: 'date_range',
          title: 'Started',
          text: this.$moment(report.startDate).format('MM/DD/YYYY [at] hh:mm A'),
        },
        {
          icon: 'update',
          title: 'Updated',
          text: this.$moment(report.lastUpdateDate).format('MM/DD/YYYY [at] hh:mm A'),
        },
      ];
    },
    attemptsInfoString() {
      const reports = sortBy(this.assignment?.reports, 'startDate');
      const currentReportIdx = reports.findIndex(r => r._id === this.report._id);
      if (currentReportIdx !== -1) {
        const currentAttempt = currentReportIdx + 1;
        const { maxAttempts } = this.assignment?.contentSettings;
        return `Attempt ${currentAttempt}/${maxAttempts}`;
      }
      return null;
    },
    previewAvailable() {
      return !!this.report?.answers?.length;
    },
  },
};
</script>
